import { Component, OnInit } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-audit-tracker-analytics',
  templateUrl: './audit-tracker-analytics.component.html',
  styleUrls: ['./audit-tracker-analytics.component.scss']
})
export class AuditTrackerAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
